import { observer, useLocalObservable } from "mobx-react"
import { Flex, Form, Typography } from "antd"

import { notify } from "@src/app/components/notify"
import {
  WhiteList,
  WhiteListCreateReq,
} from "@src/pages/settingsWhitelist/classes/WhiteList"
import { WhiteListForm } from "@src/pages/settingsWhitelist/ui/WhiteListForm"
import { WhiteListTable } from "@src/pages/settingsWhitelist/ui/WhiteListTable"
import { InlineObject17 } from "@src/shared/api/generated"
import { useCatchFormErrors } from "@src/shared/form/base_error"

export const SettingsWhitelistPage = observer(() => {
  const [form] = Form.useForm()

  const { submit } = useCatchFormErrors(
    form,
    async (data: WhiteListCreateReq) => {
      return whiteList.create(data).then(() => {
        form.resetFields()

        notify.success("Address has been added")
      })
    },
  )

  const whiteList = useLocalObservable(() => new WhiteList())

  return (
    <Flex gap={32} vertical>
      <Typography.Text style={{ fontSize: 16 }}>
        The Withdrawal Address Whitelist is a set of preapproved withdrawal
        addresses that provide additional protection against cyber attacks. It
        also safeguards your account by disabling withdrawals to newly
        whitelisted addresses for 1 hours.
      </Typography.Text>

      <WhiteListForm
        currencies={whiteList.currenciesOption}
        currenciesIsLoading={whiteList.currencies.isLoading}
        form={form}
        isLoading={whiteList.isLoading}
        submit={submit}
      ></WhiteListForm>

      {(!whiteList.collection.isEmpty || whiteList.collection.isLoading) && (
        <WhiteListTable
          collection={whiteList.collection}
          deleteFn={whiteList.delete}
        />
      )}
    </Flex>
  )
})
